/* eslint-disable no-useless-computed-key */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../static/images/ALFRED_BLACK_SVG.svg';
import LogoWs from '../static/images/LoginIMG.png';
import { RegExpValidator } from '../core/regExp-generic';
import { ErrorsIcon } from '../components/Icons/errorIcon';
import { BusinessController } from '../core/controller/BusinessCtrl';
import { ToastContainer, toast } from 'react-toastify';
import { toastError } from '../core/toast/toastAlert';


export const PasswordChange = () => {
    const businessController = new BusinessController()
    const [state, setState] = useState<any>({
        email: localStorage.getItem('email'),
        password: '',
        error: false
    });

    const [actinValid, setactinValid] = useState<string>('changePass');
    const [errors, setErrors] = useState<any>({});
    const [isFormValid, setIsFormValid] = useState<boolean>(false);
    const [titleForm, settitleForm] = useState<any>({
        changePass: {
            title: 'Change your password',
            subTitle: 'Change your default password for a new one'
        }
    });

    const navigate = useNavigate();

    const handleChange = (event: any) => {
        const { name, value } = event.target;
        setState((prevProps: any) => ({
            ...prevProps,
            [name]: value
        }))
        setIsFormValid(true);
    }

    const handleSubmit = async (event: any) => {
        try {
            event.preventDefault();
            if (!RegExpValidator['password'].test(state.password)) {
                setErrors((prevErrors: any) => ({ ...prevErrors, ['password']: true }));
                setIsFormValid(false);
                return
            } else {
                setErrors((prevErrors: any) => ({ ...prevErrors, ['password']: false }));
                setIsFormValid(true);
            }

            const dataFrom: any = {
                email: state.email || localStorage.getItem('email'),
                password: state.password,
            }
            const accessToken: string = localStorage.getItem('token') as string
            const response = await businessController.businessPasswordChange(dataFrom, accessToken)

            if(response.status >= 400) {
                toast.error(response.message, toastError)
                return
            }

            const { status, data } = response

            if (status === 201) {
                setErrors((prevErrors: any) => ({ ...prevErrors, ['passwordSuccses']: true }));
                setTimeout(() => {
                    navigate('/');
                    localStorage.removeItem('email')
                }, 3000);
            } else {
                setErrors((prevErrors: any) => ({ ...prevErrors, ['passwordSuccses']: false }));
                setState((prevProps: any) => ({
                    ...prevProps,
                    error: true
                }))
                return
            }
        }
        catch (error) {
            setErrors((prevErrors: any) => ({ ...prevErrors, ['passwordSuccses']: false }));
        }
    }

    return (
        <>
            <div className="flex h-screen w-screen">
                <div className='flex flex-col items-center justify-center w-full gap-10'>
                    <div className='login-section-img w-1/2 pl-[70px]'>
                        <img src={Logo} alt="alfredpay logo" className='logo-login' />
                    </div>
                    <div className='w-[80%]'>
                        <p className='login-welcome mb-[20px]'>{titleForm[actinValid].title}</p>
                        <p className='login-welcome-sub'>{titleForm[actinValid].subTitle}</p>
                    </div>
                    <form className='flex flex-col gap-4 items-center w-[70%]' autoComplete="on" onSubmit={handleSubmit}>
                        {
                            state.error && (
                                <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative w-full text-center" role="alert">
                                    <span className="block sm:inline">An internal error has occurred.</span>
                                </div>
                            )
                        }
                        {
                            errors.passwordSuccses && (
                                <div className="bg-green-100 border border-green-400  px-4 py-3 rounded relative" role="alert">
                                    <span className="block sm:inline">The password change was made successfully.</span>
                                </div>
                            )
                        }

                        <div className="flex flex-col w-full gap-4">
                            <div>
                                <label htmlFor="" className='login-Label'>New Password</label>
                            </div>
                            <input
                                type="password"
                                name="password"
                                required
                                pattern={String(RegExpValidator.password)}
                                className={`login-input w-full h-10 p-[10px] ${errors.password ? 'errors-input' : ''}`}
                                onChange={handleChange}
                                value={state.password}
                            />

                            <p className='login-contect-change text-justify'>
                                Password must have at least 8 characters, one Capital, one number and one simbol
                            </p>
                            {errors.password && (
                                <div className='flex errors-msm'>
                                    <ErrorsIcon className='mr-2 w-[1.5rem]' /> Wrong password, please try again
                                </div>
                            )
                            }
                        </div>

                        {
                            !errors.passwordSuccses && (
                                <button
                                    type="submit"
                                    disabled={!isFormValid}
                                    className={`${isFormValid ? 'btn-active' : 'btn-disabled'}  text-white text-center w-full p-[0.7rem] border rounded-full login-btn-text`}
                                >
                                    Change Password
                                </button>
                            )
                        }

                    </form>
                </div>
                <img className='w-full object-cover login-res' src={LogoWs} alt="" />
            </div>
            <ToastContainer />
        </>

    )
}